// extracted by mini-css-extract-plugin
export default {"wrap":"PrerequisitesRequired_wrap__LU0E8","title":"PrerequisitesRequired_title__fTEB-"};